<section (wheel)="mouseWheelScroll($event)">
  <div *ngIf="isLoading" class="loader background-background">
    <p class="loader-text user-select-none">Loading</p>
    <tr-loader [isSpinner]="true" [isFloorplan]="true"></tr-loader>
  </div>

  <div *ngIf="!isLoading" class="floorplan-switcher">
    <ng-content></ng-content>
  </div>

  <div [hidden]="isLoading" #controlsRef class="zoom-control">
    <a (click)="setZoomByAmount(1)" class="reset mx-3 my-0 user-select-none" [class.disabled]="isOnFreePlan"><b>Reset</b></a>

    <div class="background-background">
      <tablesready-btn-group-control
        [items]="zoomControls"
        [disabled]="isOnFreePlan"
        bindName="name"
        bindValue="value"
        (btnClick)="setZoomByStep($event)"
      ></tablesready-btn-group-control>
    </div>
  </div>

  <div class="canvas-anchor" #canvasFloatRef>
    <div
      class="canvas-area background-accent"
      #canvasAvailableArea
      [style.max-width.px]="canvasAreaWidth"
      [style.min-width.px]="canvasAreaWidth"
      [style.max-height.px]="canvasAreaHeightPx"
      [style.min-height.px]="canvasAreaHeightPx"
    >
    </div>

    <div class="canvas-float">
      <canvas id="{{ canvasId }}"></canvas>
    </div>

    <tablesready-frontend-scrollbar
      [noZoomWidth]="targetCanvasWidth"
      [canvasAreaWidth]="canvasAreaWidth"
      [canvasAreaHeight]="canvasAreaHeightPx + 'px'"
    >
      <div [style.width.px]="scrollableAreaWidth" [style.height.px]="scrollableAreaHeight"></div>
    </tablesready-frontend-scrollbar>
  </div>
</section>
